var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationCoffeemug = function SvgSimpleIllustrationCoffeemug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__coffeemug_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__coffeemug_svg__st0{fill:#e4bc06}.simple-illustration__coffeemug_svg__st1{fill:#fed604}.simple-illustration__coffeemug_svg__st4{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__coffeemug_svg__st6{fill:#fff4ea}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 10.3S3.8 22 8.5 25.6c4.7 3.6 8.5 3.9 10.9 3.6 2.4-.3 9.6-1.2 10.6-6.7S31.3 10 31.3 10l-27 .3zM16 34.8v12.1h3.3l2.1-.6V34.8H16z",
    className: "simple-illustration__coffeemug_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 29.1s.1 2.5.1 3 1.8 3 4.9 2.8c3.1-.1 4.8-2.8 4.8-2.8l.3-3.1c.1-.1-8 .8-10.1.1zM15.6 43.6s-4.6.5-5.1 4c-.5 3.6 7.5 4.5 9 4.3 1.5-.1 7.8-2.4 7.6-4.6-.1-2.2-5.1-3.5-5.1-3.5l-.6 2.5s-1.4.9-2.8.8c-1.5-.1-2.5-.1-2.5-.1l-.5-3.4z",
    className: "simple-illustration__coffeemug_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 24.4c1.9 0 3.5-1.5 3.5-3.4s-1.6-3.4-3.5-3.4-3.5 1.5-3.5 3.4c-.1 1.9 1.5 3.4 3.5 3.4z",
    style: {
      fill: "#f68dfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 13.8c7.3 0 13.3-2 13.3-4.4 0-2.4-6-4.4-13.3-4.4C10.5 5 4.5 7 4.5 9.4c0 2.4 6 4.4 13.3 4.4z",
    style: {
      fill: "#002140"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 9.3S1.4 29.5 18.2 29.5 31.4 9.3 31.4 9.3",
    className: "simple-illustration__coffeemug_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3c7.4 0 13.4-1.8 13.4-4s-6-4-13.4-4-13.4 1.8-13.4 4 6 4 13.4 4zM18.4 24.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.5 3.5 3.5 3.5zM23.1 29c.3.5.4 1.1.4 1.7 0 2.4-2.4 4.3-5.3 4.3s-5.3-1.9-5.3-4.3c0-.5.1-1 .3-1.4M15.8 34.7v11.7M21.6 34.7v11.7M15.8 46.4s.8.9 2.7.9 3.1-.9 3.1-.9",
    className: "simple-illustration__coffeemug_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 43.6c3.1.7 5.2 2.2 5.2 4 0 2.4-3.8 4.3-8.4 4.3s-8.4-1.9-8.4-4.3c0-1.8 2.1-3.3 5.1-4",
    className: "simple-illustration__coffeemug_svg__st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 29.8s2.1-.2 2.1-1-.9-1.8-3.6-2.5c-2.6-.6-6.2-.9-9-.8s-11.3.7-12 2.5c-.6 1.7 2.6 2.2 2.6 2.2s2.9-2.3 10-2.2c7.1.1 9.9 1.8 9.9 1.8z",
    style: {
      fill: "#ffecac"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 28.8s-2.6 2.6-7.9 2.5c-5.2-.1-9.7-.2-10.6-.4-.9-.2-6.3-1.6-6.3-1.6l.1 22.5s3.9 2 11.1 2c7.1 0 13.1-.9 13.7-2.6l-.1-22.4z",
    className: "simple-illustration__coffeemug_svg__st6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 29.8s-2.9-1.8-10.7-1.7c-7.8.1-9.1 1.7-9.1 1.7s2.2 1.4 10.2 1.5c8 0 9.6-1.5 9.6-1.5z",
    style: {
      fill: "#722b03"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 44.1v5.2s9.8-.5 9.8-8.9-7.5-10.8-9.7-10.6v5.1s4.3 1.6 4.3 4.9-4.4 4.3-4.4 4.3z",
    className: "simple-illustration__coffeemug_svg__st6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 31.2c6.8 0 12.4-1.3 12.4-2.8s-5.5-2.8-12.4-2.8c-6.8 0-12.4 1.3-12.4 2.8s5.6 2.8 12.4 2.8zM46 51.2c0 1.5-5.6 2.8-12.4 2.8-6.8 0-12.4-1.3-12.4-2.8M21.2 51.2V28.4M46 51.2V28.4",
    className: "simple-illustration__coffeemug_svg__st4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 30c1.3-1.1 5.4-1.9 10.2-1.9 4.4 0 8.2.7 9.9 1.6M46.2 29.8c5.4 0 9.7 4.4 9.7 9.7 0 5.4-4.4 9.7-9.7 9.7",
    className: "simple-illustration__coffeemug_svg__st4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35c2.4 0 4.4 2 4.4 4.4 0 2.4-2 4.4-4.4 4.4",
    className: "simple-illustration__coffeemug_svg__st4"
  })));
};
export default SvgSimpleIllustrationCoffeemug;